
export const EnvironmentUrl = window.FB.ApiBaseUrl;
export const globalProject = window.FB;

export const ViewPort = {
	Desktop: 'desktop',
	Tablet: 'tablet',
	Mobile: 'mobile'
};

export const Breakpoints = {
	Desktop: '970',
	Tablet: '750'
};